module.exports = __webpack_public_path__ + "static/murathan-yildirim-flatart-a839f827b6b7014f504190ec5b991960.jpg";